import AppService from './AppService'
const baseURL = '/api/projects'
const API = AppService.initAPI(baseURL)

const Services = {
    
    create: async function (body) {
        return await API.post(``, body)
    },

    find: async function (params) {
        return await API.get(``, {params})
    },

    findUsers: async function (id, params) {
        return await API.get(`/${id}/users`, {params})
    },

    updateUser: async function (id, userId, body) {
        return await API.put(`/${id}/users/${userId}`, body)
    },

    update: async function (id, body) {
        return await API.put(`/${id}`, body)
    },
};
export default Services